<div class="row giftcard-note no-margin-bottom" [class.hidden]="!showOrderBanner" [class.active]="showOrderBanner" *ngIf="showOrderBanner">
  <div class="col s12 m12 l12">
    <div class="row no-margin-bottom valign-wrapper">
      <div class="col s2 offset-s1 m2 offset-m2 l2 offset-l2 giftcard-logo" *ngIf="showMerchantLogo">
        <img *ngIf="merchantName && merchantName.length > 0" [src]="s3BucketUrl + '/logo-icons/' + (merchantName | lowercase) + '-logo-icon.png'">
      </div>
      <div [class]="showMerchantLogo ? 'col s9 m8 l8' : 'col s12 m12 l12'">
        <div class="row no-margin-bottom" [class.center]="!showMerchantLogo">
          <div class="col s12 m12 l12" *ngIf="message && message.length > 0">
            <span class="message" [textContent]="message"></span>
          </div>
          <div class="col s12 m12 l12" *ngIf="basketAmount && basketAmount > 0">
            <span *ngIf="basketAmount && basketAmount > 0" class="amount" [textContent]="basketAmount | RupeeCurrencyPipe"></span>
            <span *ngIf="emi && emi > 0" class="tenure" [textContent]="'EMI '"></span>
            <span *ngIf="emi && emi > 0" class="tenure" [textContent]="(emi | RupeeCurrencyPipe) + '/month'"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>